module.exports = __webpack_public_path__ + "static/img/666.01dae33c.png";